import { defineStore } from "pinia";

export const useNotificationsStore = defineStore("notifications", {
  state: () => ({
    lastNotification: null,
    dismissRequestedAt: 0,
    dismissedKeys: [],
  }),

  actions: {
    dismissNotifications() {
      this.dismissRequestedAt = Date.now();
    },

    dismissNotification(key) {
      this.dismissedKeys.push(key);
    },

    takeDismissedKeys() {
      return this.dismissedKeys.splice(0);
    },

    showSuccessNotification(message) {
      this.lastNotification = {
        timeout: 3000,
        position: "center",
        color: "success",
        text: message,
      };
    },

    showErrorNotification(
      message,
      { actions = [], timeout = 3000, key = null } = {}
    ) {
      this.lastNotification = {
        timeout,
        position: "center",
        color: "error",
        text: message,
        actions,
        key,
      };
    },

    showWarningNotification(
      message,
      { actions = [], timeout = 3000, key = null } = {}
    ) {
      this.lastNotification = {
        timeout,
        position: "center",
        color: "warning",
        text: message,
        actions,
        key,
      };
    },
  },
});
